<template>
  <router-view></router-view>
  <div id="modal-container"></div>
  <div id="global-croppers" class="absolute bottom-0 left-0 right-0 top-0 -z-40"></div>
</template>

<script setup lang="ts">
  import { RouterView } from 'vue-router';
  import { createHead } from 'unhead';
  import { useAppInsightsLogger } from '@core/plugins/appInsights';
  // Create a global head instance
  const head = createHead();
  useAppInsightsLogger();
</script>
